module.exports = __webpack_public_path__ + "img/ComentariosIcon.1adfc6e8.svg";